exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".timeline-4cefb .ant-timeline-item-tail{top:14px;height:calc(100% - 16px);border-left:3px solid #1677ff}.timeline-4cefb .ant-timeline-item-head{width:12px;height:12px;border-width:2px;background-color:#1677ff}.timeline-4cefb .ant-timeline-item-content{margin-left:24px;font-size:16px}.timeline-4cefb.highlight-fda1c .ant-timeline-item:not(:first-child) .ant-timeline-item-head{background-color:rgba(0,0,0,0)}", ""]);

// Exports
exports.locals = {
	"timeline": "timeline-4cefb",
	"highlight": "highlight-fda1c"
};